import React from 'react';
import Typography from '@mui/material/Typography';

export default function GeminiModelLabel({ model }) {
  const status = ['retiring', 'preview'].includes(model.lifecycle) ? model.lifecycle : '';
  return (
    <>
      {model.label}
      {status && (
        <Typography component="em" variant="caption"
          sx={{ ml: 1, color: status === 'preview'
            ? 'var(--color-light-blue-text)' : 'var(--color-medium-orange)' }}>
          {status}
        </Typography>
      )}
    </>
  );
}
